import {
  ChatPrompt,
  ChatPromptCreateRequest,
  ChatPromptListParams,
  ChatPromptListResponse,
  ChatPromptUpdateRequest
} from '../types/chatPrompt';
import { ApiClient } from './apiClient';

export class ChatPromptService {
  constructor(private api: ApiClient) { }

  async list(params?: ChatPromptListParams) {
    const search = params?.search?.trim();
    const query: Record<string, string | number | undefined> = {
      page: params?.page ?? 1,
      limit: params?.limit ?? 20,
      ...(search ? { search } : {})
    };

    const result = await this.api.get<ChatPromptListResponse>('/api/chat-prompts', query);
    const response = result.success && result.data
      ? result.data
      : {
        data: [],
        meta: {
          page: Number(params?.page ?? 1),
          limit: Number(params?.limit ?? 20),
          total: 0,
          totalPages: 0
        }
      };

    return {
      data: response.data ?? [],
      meta: response.meta ?? {
        page: 1,
        limit: 20,
        total: 0,
        totalPages: 0
      }
    };
  }

  getById(id: number) {
    return this.api
      .get<ChatPrompt>(`/api/chat-prompts/${id}`)
      .then(result => (result.success && result.data ? result.data : null));
  }

  create(payload: ChatPromptCreateRequest) {
    return this.api
      .post<ChatPrompt>('/api/chat-prompts', payload)
      .then(result => (result.success && result.data ? result.data : null));
  }

  update(id: number, payload: ChatPromptUpdateRequest) {
    return this.api
      .put<ChatPrompt>(`/api/chat-prompts/${id}`, payload)
      .then(result => (result.success && result.data ? result.data : null));
  }

  delete(id: number) {
    return this.api.delete<void>(`/api/chat-prompts/${id}`).then(() => undefined);
  }
}
